/*
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-14 15:41:49
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2024-06-19 11:31:27
 */
import Vue from 'vue'
// import "babel-polyfill"
// import promise from "es6-promise"
import App from './App.vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 移动端适配
import 'lib-flexible/flexible.js'
// svg-icon
import './assets/icons' // icon
import './styles/index.less'
// 引入自定义css是为了覆盖掉默认的进度条的颜色
import './styles/m/nprogress.less'
import './permission' // permission

import 'swiper/css/swiper.min.css'
import 'swiper/js/swiper.min.js'
import Swiper from 'swiper'

import i18n from './utils/i18n'
import store from './store'
import router from './router'

import { Image as VanImage, Collapse, CollapseItem, Field, Dialog, List } from 'vant'
Vue.use(VanImage).use(Collapse).use(CollapseItem).use(Field).use(Dialog).use(List)

Vue.prototype.$Swiper = Swiper

Vue.use(ElementUI)

Vue.config.productionTip = false
let language = 'zh'
if (location.origin === process.env.VUE_APP_HOST_EN) {
  language = 'en'
}
store.dispatch('app/setLanaguage', language).then(() => {
  i18n.locale = language
})
store.dispatch('app/setI18nLocale', language)
// i18n.locale = store.getters.language
// store.dispatch('app/setLanaguage', 'zh')
// i18n.locale = 'zh'

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
